import React, { useEffect, useState } from "react";
import { object, array, bool, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import Organism3 from "./Organism3";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug } from "../../utils/utils";

import "./sixStories1AdWithTagSearch.m.css";

const SixStories1AdWithTagSearch = ({
  collection,
  sections,
  isSectionComponent = false,
  firstStoriesSet,
  widgetUrl = null,
  domainSlug
}) => {
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    setIsDesktop(global.deviceWidth >= 1264);
  }, []);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const list = !firstStoriesSet ? collection.items.filter(item => item.type === "story") : firstStoriesSet;
  const storyList = !firstStoriesSet ? list.slice(0, 11) : firstStoriesSet;
  const collectionSlug = getSlug(collection, sections, domainSlug);

  if (!storyList.length) {
    return null;
  }

  return (
    <div styleName="base" className="six-stories-1ad-with-tag-search" data-testid="six-stories-tag">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionName={collection.name}
          collectionSlug={collectionSlug}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName="wrapper">
        <div>
          <Organism1 storyList={isDesktop ? storyList.slice(0, 3) : storyList.slice(0, 6)} updatedFont={true} />
          <Organism2 storyList={storyList.slice(3, 7)} className="organism-2" updatedFont={true} />
        </div>
        <Organism3
          className="organism-3"
          isSectionComponent={isSectionComponent}
          widgetUrl={widgetUrl}
          collectionSlug={collectionSlug}
        />
      </div>
    </div>
  );
};

SixStories1AdWithTagSearch.propTypes = {
  collection: object,
  sections: array,
  isSectionComponent: bool,
  firstStoriesSet: array,
  widgetUrl: string,
  domainSlug: string
};

const mapStateToProps = state => {
  return {
    sections: get(state, ["qt", "config", "sections"], []),
    domainSlug: get(state, ["qt", "config", "domainSlug"], "")
  };
};

export default connect(mapStateToProps)(SixStories1AdWithTagSearch);
